import { PatientHistoryType } from 'src/graphql.generated'
import { useGetPatientHistoryPrefillDataQuery } from './getPatientHistoryPrefillData.generated'

export function useGetPatientHistoryPrefillData(uid: string, type: PatientHistoryType, callID?: string | null) {
  const { data, loading, refetch, error } = useGetPatientHistoryPrefillDataQuery({
    variables: { uid, type, callID: callID ?? null },
    fetchPolicy: 'cache-and-network',
  })
  return { data: data?.patientHistoryPrefillData, loading, refetch, error }
}
